import { SVGProps } from "react";
import styles from "./ChanelBanner.module.scss";

const ChanelSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 284.991 44.453"
    width="100"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Chanel banner</title>
    <path d="M60.586 16.292V.632h-8.428V43.69h8.428V25.316h20.669V43.7h8.465V.632h-8.491v15.646zM239.514.639H208.84V43.69h32.676v-8.264h-23.958v-9.258h19.491v-8.692h-19.491V8.944h21.928zM186.466 43.69h6.818V.646h-8.414v25.698L166.378.646h-11.063V43.69h8.236V11.761zM128.142.646h-11.538L97.41 43.69h9.056l4.263-9.55h22.688l4.281 9.55h9.544zM114.594 25.53l7.546-17.065 7.5 17.065zM262.356.628l-8.723.011V43.69h31.358v-8.264h-22.635zM42.173 32.003c-3.625 7.354-11.193 12.45-19.947 12.45C9.952 44.453 0 34.502 0 22.227S9.952 0 22.227 0A22.19 22.19 0 0141.67 11.423l-7.319 4.169C32.007 11.305 27.46 8.53 22.23 8.53c-7.623 0-13.601 6.079-13.601 13.703 0 7.627 5.978 13.704 13.601 13.704 5.5 0 10.142-3.246 12.363-7.899z" />
  </svg>
);

export const ChanelBannerUI = () => {
  const chanelLandingPage = "/beauty/chanel/c7000370531";

  return (
    <a
      className={styles.banner}
      href={chanelLandingPage}
      data-component="BrandBanner"
    >
      <ChanelSvg
        height={48}
        style={{ display: "block", margin: "0 auto", pointerEvents: "none" }}
      />
    </a>
  );
};
